import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function EarlyPayday({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M3.33341 2.66669C2.96522 2.66669 2.66675 2.96516 2.66675 3.33335V14C2.66675 14.3682 2.96522 14.6667 3.33341 14.6667H10.0001V13.3334H4.00008V4.00002H20.0001V13.3334H14.0001V14.6667H20.6667C21.0349 14.6667 21.3334 14.3682 21.3334 14V3.33335C21.3334 2.96516 21.0349 2.66669 20.6667 2.66669H3.33341Z"
        fill={iconColor}
      />
      <Path
        d="M12.4715 21.8048C12.2111 22.0651 11.789 22.0651 11.5287 21.8048L6.86201 17.1381L7.80482 16.1953L11.3334 19.7239V13.3334H12.6667V19.7239L16.1953 16.1953L17.1382 17.1381L12.4715 21.8048Z"
        fill={iconColor}
      />
      <Path
        d="M12.6667 8.00002H6.00008V6.66669H12.6667V8.00002Z"
        fill={iconColor}
      />
      <Path
        d="M6.00008 10.6667H14.6667V9.33335H6.00008V10.6667Z"
        fill={iconColor}
      />
    </Svg>
  );
}
